import { apiUrl } from "../constans";
import apiClient from '../libs/axios';

const API_BASE = `${apiUrl}/v2/ai/usage`;
const API_MEMBRESIAS = `${apiUrl}/v2/membersheps`;

const aiUsage = {
    namespaced: true,
    state: {
        periodo: null,
        totalUsd: 0,
        costoPorConversacionUsd: 0,
        porFuncion: [],
        usuarios: [],
        // Resultados de búsqueda del listado de membresías, para el selector de usuario
        miembros: [],
        miembrosTotal: 0,
        loadingMiembros: false,
        loading: false,
        error: null,
    },

    mutations: {
        setMiembros(state, { miembros, total }) {
            state.miembros = miembros;
            state.miembrosTotal = Number(total || 0);
        },

        setLoadingMiembros(state, loading) {
            state.loadingMiembros = loading;
        },

        setUsage(state, data) {
            state.periodo = data?.periodo || null;
            state.totalUsd = Number(data?.total_usd || 0);
            state.costoPorConversacionUsd = Number(data?.costo_por_conversacion_usd || 0);
            state.porFuncion = data?.por_funcion || [];
            state.usuarios = data?.usuarios || [];
        },

        clearUsage(state) {
            state.periodo = null;
            state.totalUsd = 0;
            state.costoPorConversacionUsd = 0;
            state.porFuncion = [];
            state.usuarios = [];
        },

        setLoading(state, loading) {
            state.loading = loading;
        },

        setError(state, error) {
            state.error = error;
        },

        clearError(state) {
            state.error = null;
        },
    },

    actions: {
        // filtros: { desde, hasta, user_id } — todos opcionales.
        // Sin filtros la API devuelve el mes en curso.
        async getAiUsageAction({ commit }, filtros = {}) {
            commit('setLoading', true);
            commit('clearError');
            try {
                const params = {};
                if (filtros.desde) params.desde = filtros.desde;
                if (filtros.hasta) params.hasta = filtros.hasta;
                if (filtros.user_id) params.user_id = filtros.user_id;

                const response = await apiClient.get(API_BASE, { params });
                const data = response.data.data || response.data;
                commit('setUsage', data);
                return data;
            } catch (error) {
                commit('setError', error.response?.data?.message || 'Error al cargar el consumo de IA');
                throw error;
            } finally {
                commit('setLoading', false);
            }
        },

        // Búsqueda server-side contra el mismo listado de Membresías.
        // Ese endpoint pagina de 8 en 8 y no acepta per_page, así que no se
        // puede precargar entero: se consulta por término y se muestra la 1ª página.
        async buscarMiembrosAction({ commit }, termino) {
            const q = (termino || '').trim();
            if (q.length < 3) {
                commit('setMiembros', { miembros: [], total: 0 });
                return [];
            }

            commit('setLoadingMiembros', true);
            try {
                // El backend filtra por `nameAgent` o por `email`; mandamos solo uno
                const filtros = q.includes('@') ? { email: q } : { nameAgent: q };
                const response = await apiClient.post(`${API_MEMBRESIAS}?page=1`, filtros);
                const paginado = response.data.data || {};

                const miembros = (paginado.data || []).map((u) => ({
                    value: u.id,
                    label: u.userdata?.primer_nombre
                        ? `${u.userdata.primer_nombre} — ${u.email || ''}`.replace(/ — $/, '')
                        : (u.email || `Usuario #${u.id}`),
                }));

                commit('setMiembros', { miembros, total: paginado.total });
                return miembros;
            } catch (error) {
                // El selector es accesorio: si falla, la pantalla sigue siendo útil
                commit('setMiembros', { miembros: [], total: 0 });
                return [];
            } finally {
                commit('setLoadingMiembros', false);
            }
        },
    },
};

export default aiUsage;
